module.exports = __webpack_public_path__ + "img/ic_redcar_ly.d9f2c8b0.png";